"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function CollectionCalendar({ className, dateTime, day, month, ...props }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('usa-collection__calendar-date', className), ...props, children: (0, jsx_runtime_1.jsxs)("time", { dateTime: dateTime, children: [(0, jsx_runtime_1.jsx)("span", { className: "usa-collection__calendar-date-month", children: month }), (0, jsx_runtime_1.jsx)("span", { className: "usa-collection__calendar-date-day", children: day })] }) }));
}
exports.default = CollectionCalendar;
